// Difficulty order mapping
const difficultyOrder = {
  Easy: 1,
  Medium: 2,
  'Somewhat Challenging': 3,
  Hard: 4,
  'Very Hard': 5,
};

/**
 * Sorts an array of questions by difficulty level
 * @param questions - Array of questions to sort
 * @returns Sorted array of questions (Easy to Very Hard)
 */
export const sortQuestionsByDifficulty = <T extends { categories?: any[] }>(
  questions: T[],
): T[] => {
  return [...questions].sort((a, b) => {
    const difficultyA =
      a.categories
        ?.find((cat: any) => cat.startsWith('Difficulty:'))
        ?.split(':')[1]
        ?.trim() || '';
    const difficultyB =
      b.categories
        ?.find((cat: any) => cat.startsWith('Difficulty:'))
        ?.split(':')[1]
        ?.trim() || '';
    const orderA = difficultyOrder[difficultyA] || 999;
    const orderB = difficultyOrder[difficultyB] || 999;
    return orderA - orderB;
  });
};

/**
 * Re-numbers question titles to be sequential (1, 2, 3, etc.)
 * @param questions - Array of questions with title property
 * @returns Array of questions with corrected sequential titles
 */
export const renumberQuestions = <T extends { title?: string; [key: string]: any }>(
  questions: T[],
): T[] => {
  return questions.map((question, index) => ({
    ...question,
    title: `Question ${index + 1}`,
  }));
};
